import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
// material
import { Box, Button, Grid } from '@mui/material';

import { CustomModal, HoverLoader } from 'components';

interface Props {
    open: boolean;
    closeModal: () => void;
    headerText: string;
    previewTemplate: any;
    handleSendBulkMail:any;
}

const BulkMailPreview = (props: Props) => {
    const { closeModal, open, headerText, handleSendBulkMail, previewTemplate } = props;
    const { formatMessage } = useIntl();

    return (
        <CustomModal
            open={open}
            onClose={closeModal}
            title={headerText}
            size='xxl'
        >
            <Box sx={{ padding: 3, background: '#f2f2f2' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        {previewTemplate && <>
                            <h4>Subject : {previewTemplate.subject}</h4>
                            <iframe
                                srcDoc={previewTemplate.html}  // emailPreviewHtml includes <html>...<body>...</body></html>
                                style={{ width: '100%', height: '500px', overflow:'auto', border: 'none' }}
                                title="Email Preview"
                            />
                        </>
                        }
                    </Grid>
                    <Grid item xs={9} />
                    <Grid item xs={3} onClick={handleSendBulkMail} justifyContent='flex-end'>
                        <Button variant='contained' fullWidth size='large'>
                            {formatMessage({ id: "send" })}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </CustomModal>
    )
}

export default BulkMailPreview;